"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Configure } from "react-instantsearch";
import { InstantSearchNext } from "react-instantsearch-nextjs";
import { PiiScrubBridge } from "@/components/custom/Plp/PiiScrubBridge";
import { PlpAnalyticsBridge } from "@/components/custom/Plp/PlpAnalyticsBridge";
import { PlpQueryOwner } from "@/components/custom/Plp/PlpQueryOwner";
import { PlpResultAnnouncer } from "@/components/custom/Plp/PlpResultAnnouncer";
import { buildTypesenseSearchClient, PRODUCTS_INDEX_NAME } from "@/lib/search/instantsearchClient";
import { createPlpStateMapping, PLP_HISTORY_ROUTER_OPTIONS, type PlpUiState } from "@/lib/search/instantsearchRouting";
import { PRODUCTS_DISJUNCTIVE_FACETS, PRODUCTS_SINGLE_SELECT_FACETS } from "@/lib/search/queryConfig";
import { PlpResultsView } from "./PlpResultsView";
interface Props {
  pageTitle: string;
  productTypeBakedIn?: boolean;
  bakedFilters?: string;
  bakedAttributes?: Readonly<Record<string, string>>;
  initialUiState?: PlpUiState;
}
export function PlpResultsClient(t0) {
  const $ = _c(23);
  const {
    pageTitle,
    productTypeBakedIn,
    bakedFilters,
    bakedAttributes,
    initialUiState
  } = t0;
  const [searchClient] = useState(_temp);
  let t1;
  if ($[0] !== bakedAttributes) {
    t1 = () => createPlpStateMapping({
      bakedAttributes
    });
    $[0] = bakedAttributes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [stateMapping] = useState(t1);
  let t2;
  if ($[2] !== stateMapping) {
    t2 = {
      router: PLP_HISTORY_ROUTER_OPTIONS,
      stateMapping
    };
    $[2] = stateMapping;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      preserveSharedStateOnUnmount: true
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== bakedFilters) {
    t4 = <Configure hitsPerPage={48} facets={PRODUCTS_SINGLE_SELECT_FACETS} disjunctiveFacets={PRODUCTS_DISJUNCTIVE_FACETS} filters={bakedFilters} />;
    $[5] = bakedFilters;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PiiScrubBridge />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== bakedAttributes || $[9] !== pageTitle || $[10] !== productTypeBakedIn) {
    t6 = <PlpResultsView pageTitle={pageTitle} productTypeBakedIn={productTypeBakedIn} bakedAttributes={bakedAttributes} />;
    $[8] = bakedAttributes;
    $[9] = pageTitle;
    $[10] = productTypeBakedIn;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PlpQueryOwner />;
    t8 = <PlpResultAnnouncer />;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  const t9 = bakedAttributes?.productType;
  let t10;
  if ($[14] !== t9) {
    t10 = <PlpAnalyticsBridge category={t9} />;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== initialUiState || $[17] !== searchClient || $[18] !== t10 || $[19] !== t2 || $[20] !== t4 || $[21] !== t6) {
    t11 = <InstantSearchNext searchClient={searchClient} indexName={PRODUCTS_INDEX_NAME} initialUiState={initialUiState} routing={t2} future={t3}>{t4}{t5}{t6}{t7}{t8}{t10}</InstantSearchNext>;
    $[16] = initialUiState;
    $[17] = searchClient;
    $[18] = t10;
    $[19] = t2;
    $[20] = t4;
    $[21] = t6;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}
function _temp() {
  return buildTypesenseSearchClient();
}